import {
    Component,
    OnInit,
    Input,
    ChangeDetectorRef,
    Output,
    EventEmitter,
    SimpleChanges
} from '@angular/core';
import { ReviewService } from 'src/app/services/review-service/review.service';
import { ReviewInterface } from 'src/app/model/reviews/review-interface';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { Router } from '@angular/router';
import { OrganisationService } from '../../../services/dataServices/organisation-service/organisationservice';
import { UtilService } from 'src/app/services/util-service/utilService';
@Component({
    selector: 'app-reviews',
    templateUrl: './reviews.component.html',
    styleUrls: ['./reviews.component.css'],
    standalone: false
})
export class ReviewsComponent implements OnInit {
    private readonly showInitialLinesAmount: number = 4;
    @Input() reviewType: number;
    @Input() targetId: number;
    @Input() reviews: ReviewInterface[];
    @Input() showWriteReview: boolean;

    @Output() reviewChangeEmitter = new EventEmitter();
    @Output() upvoteEmitter = new EventEmitter<ReviewInterface>();
    @Output() private reviewsChanged = new EventEmitter<ReviewInterface[]>();
    @Output() reviewCloseEmitter = new EventEmitter();
    @Output() reviewOpenEmitter = new EventEmitter();

    editState: boolean;
    public sortMethod: string = 'stars'; 
    public sortOptions = [
        { name: 'stars', title: 'Beste Bewertung' },
        { name: 'date', title: 'Neueste zuerst' },
        { name: 'upvotes', title: 'Meiste Upvotes' }
    ];

    constructor(
        private reviewService: ReviewService,
        private dialogService: DialogService,
        private changeDetector: ChangeDetectorRef,
        public userService: UserService,
        private router: Router,
        private utilService: UtilService,
    ) {}
    ngOnInit(): void {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.reviews && changes.reviews.currentValue) {
            this.setHasLongDescriptionForReviews();
            this.sortReviews();
        }
    }

    deleteReview(review: ReviewInterface): void {
        this.dialogService
            .openConfirmDialog(
                'Wollen Sie die Bewertung wirklich löschen?',
                'Nein',
                'Ja'
            )
            .subscribe((result) => {
                if (result) {
                    this.reviewService
                        .deleteReview(review)
                        .subscribe((deleted) => {
                            this.dialogService.openDialog(
                                'Bewertung erfolgreich gelöscht',
                                ''
                            );
                            this.reviews = this.reviews.filter(
                                (rev) => review !== rev
                            );
                            this.reviewsChanged.emit(this.reviews);
                            this.changeDetector.detectChanges();
                        });
                }
            });
    }

    reportReview(review: ReviewInterface): void {
        this.dialogService
            .openReportReviewDialog('Abbrechen', 'Bewertung melden')
            .subscribe((reportReason) => {
                if (reportReason) {
                    this.reviewService.createReport(
                        reportReason,
                        review.reviewId
                    );
                    this.dialogService.openDialog(
                        'Bewertung wurde gemeldet',
                        ''
                    );
                }
            });
    }

    async getAllReviews() {
        this.reviews = await this.reviewService.getReviews(
            this.reviewType,
            this.targetId
        );
    }

    addReview(newReview: ReviewInterface): void {
        this.reviews.push(newReview);
        this.reviewsChanged.emit(this.reviews);
        this.changeDetector.detectChanges();
    }

    editReview(
        editedReview: ReviewInterface,
        oldReview: ReviewInterface
    ): void {
        this.reviews[this.reviews.indexOf(oldReview)] = editedReview;
        this.setHasLongDescriptionForReviews();
        this.reviewsChanged.emit(this.reviews);
        this.changeDetector.detectChanges();
    }

    checkOverflow(elementId): boolean {
        //
        let element = document.getElementById(String(elementId));
        //
        return element.offsetHeight < element.scrollHeight;
    }

    upvoteClick(review: ReviewInterface) {
        this.reviewService
            .upvoteReview(review.reviewId, this.userService.currentUser.userId)
            .subscribe((newReview: ReviewInterface) => {
                this.editReview(newReview, review);
            });
    }

    hasUserUpvoted(review: ReviewInterface) {
        return review.upvotes.some(
            (upvote: number) =>
                this.userService.currentUser &&
                upvote === this.userService.currentUser.userId
        );
    }

    /**
     * Determines whether the user has already submitted a review for the product.
     *
     * @returns boolean
     */
    hasUserReviewedProduct(): boolean {
        return this.reviews.some(
            (review: ReviewInterface) =>
                review.creatorId == this.userService.currentUser.userId
        );
    }

    /**
     * Setzt den Boolean-Wert für alle reviews, ob der "Mehr/Weniger anzeigen"-Button erscheinen soll
     */
    private setHasLongDescriptionForReviews(): void {
        this.reviews.forEach((review: ReviewInterface) => {
            if (this.utilService.containsTooManyParagraphs(review.reviewText, this.showInitialLinesAmount)) {
                review.hasLongDescription = true;
                review.showComplete = false;
                review.shortReviewText = this.utilService.generateShortReviewText(
                    review.reviewText, this.showInitialLinesAmount
                );
            } else {
                review.hasLongDescription = false;
                review.showComplete = true;
            }
        });
    }


    /* Navigates to the Public User Profile of the User with the given Username */
    // public navigateToUserPrivateProfile(username: string) {
    //   this.router.navigate(["profil", username, "public"]);
    //   window.scrollTo(0,0);
    // }

    /* Navigates to the User Profile of the User with the given Username for logged in Users */
    public navigateToUserProfile(username: number, index: number) {
        // if (this.userService.loggedIn) {
        //     this.router.navigate(['profil', username]);
        // } else {
        //     this.router.navigate(['profil', username, 'public']);
        // }
        // window.scrollTo(0, 0);

        this.dialogService.openUserReviewHistoryDialog(username.toString(), index)
        // .subscribe((result) => {
        //      });
    }


    public showReview(): void {
        this.showWriteReview = true;
        this.reviewOpenEmitter.emit();
        this.changeDetector.detectChanges();
    }

    public cancelReview(review?: ReviewInterface): void {
        if (review) {
            review.onEdit = false;
        }
        this.reviewCloseEmitter.emit();
    }

    public onSortSelectionChange(event: any): void {
        this.sortReviews();
    }

    private sortReviews(): void {
        if (!this.reviews) return;

        this.reviews.sort((a, b) => {
            switch (this.sortMethod) {
                case 'date':
                    return new Date(b.publishDate ?? 0).getTime() - new Date(a.publishDate ?? 0).getTime();
                case 'upvotes':
                    return (b.upvotes?.length ?? 0) - (a.upvotes?.length ?? 0);
                case 'stars':
                default:
                    return (b.stars ?? 0) - (a.stars ?? 0);
            }
        });
    }
}
